










import Vue from 'vue'
export default Vue.extend({
  props: {
    label: {
      type: String,
      required: true
    },
    focus: {
      type: String,
      required: true
    },
    bg: {
      type: String,
      required: false
    }
  }
})
